/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScheduledOccupancyType = {
    Outs: 'MOVE_OUTS',
    Ins: 'MOVE_INS'
} as const;
export type ScheduledOccupancyType = typeof ScheduledOccupancyType[keyof typeof ScheduledOccupancyType];


export function ScheduledOccupancyTypeFromJSON(json: any): ScheduledOccupancyType {
    return ScheduledOccupancyTypeFromJSONTyped(json, false);
}

export function ScheduledOccupancyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledOccupancyType {
    return json as ScheduledOccupancyType;
}

export function ScheduledOccupancyTypeToJSON(value?: ScheduledOccupancyType | null): any {
    return value as any;
}

